'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _systemError = require('./systemError');

var _systemLoading = require('./systemLoading');

exports.default = {
  systemReportError: _systemError.systemReportError,
  systemCleanError: _systemError.systemCleanError,
  systemShowLoading: _systemLoading.systemShowLoading,
  systemHideLoading: _systemLoading.systemHideLoading
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/actions/index.js
// module id = z4jK
// module chunks = 4